import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import AiSummaryIframe from './AiSummaryIframe';

export interface ProjectCardProps {
  project: any;
  onEdit: (project: any) => void;
  onDelete: (project: any) => void;
  onRefresh?: (project: any) => void;
  userId: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, onEdit, onDelete, onRefresh, userId }) => {
  const [showAiSummary, setShowAiSummary] = useState(false);

  console.log('ProjectCard project data:', {
    revisionComparisionId: project.revisionComparisionId,
    projectName: project.fileName || project.name,
    hasRevisionId: !!project.revisionComparisionId && project.revisionComparisionId.trim() !== ''
  });

  return (
    <Card className="bg-paper border-parchment-400 shadow-paper text-custom-blue-900 min-h-[260px] flex flex-col justify-between">
      <CardHeader>
        <CardTitle className="text-custom-blue-900">{project.fileName || project.name || 'Untitled Project'}</CardTitle>
        <CardDescription className="text-custom-blue-600">
          {project.category} • {project.completedStories ?? 0} / {project.numberOfStories ?? project.total ?? 0} stories complete
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="w-full bg-parchment-200 rounded-full h-2">
            <div className="bg-green-500 h-2 rounded-full" style={{ width: `${project.progress}%` }}></div>
          </div>
          <div className="flex justify-between text-sm text-black">
            <span>Progress: {project.progress}%</span>
            <span>Due: {project.dueDate ? new Date(project.dueDate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : ''}</span>
          </div>
          {/* Only show the message if numberOfChars is greater than 0 */}
          {project.numberOfChars > 0 && (
            <div className="text-xs text-custom-blue-700">
              {`Awesome! You've written ${project.numberOfChars} characters so far!`}
            </div>
          )}
          <Button size="sm" className="bg-yellow-500 hover:bg-yellow-600 text-white w-full mb-2" onClick={() => onRefresh && onRefresh(project)}>
            Project Refresh
          </Button>
          {project.revisionComparisionId && project.revisionComparisionId !== null && project.revisionComparisionId.trim() !== '' && (
            <>
              <Button size="sm" className="bg-green-700 hover:bg-green-800 text-white w-full mb-2" onClick={() => setShowAiSummary(true)}>
                Create Summary
              </Button>
              {showAiSummary && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full relative flex flex-col items-center">
                    <AiSummaryIframe
                      onCancel={() => setShowAiSummary(false)}
                      onConfirm={() => setShowAiSummary(false)}
                      comparisionId={project.revisionComparisionId}
                      userId={userId}
                      onCloseAll={async () => {
                        if (typeof window !== 'undefined') setShowAiSummary(false);
                        if (userId) {
                          const { fetchProjects } = await import('../../api/projectsApi');
                          const data = await fetchProjects(userId);
                          if (data && Array.isArray(data.projects)) {
                            // Ideally, lift setProjects to parent via prop
                            window.dispatchEvent(new CustomEvent('refreshProjects', { detail: data.projects }));
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          <div className="flex gap-2 mt-4">
            <Button size="sm" className="bg-custom-blue-600 hover:bg-custom-blue-700 text-white flex-1" onClick={() => onEdit(project)}>Update</Button>
            <Button size="sm" variant="destructive" className="flex-1" onClick={() => onDelete(project)}>Delete</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectCard;
